<!-- 单项选择题 -->
<template>
    <div class="topic_choice">
        <div class="flex topic_select" :class="topicInfo.showAnalysis ? 'topic_select_none' : ''">
            <div class="topic_type">{{topicInfo.questionTypeName}}</div>
            <div class="topic_content scroll_x mar_left_10 flex-1">
                <div class="topic_title" v-html="topicInfo?.questionTitle" v-mathml></div>
                <div class="flex Flexalign mt-15" v-if="getAudioUrl(topicInfo.otherRule)">
                    <div class="mr-10">音频：</div><audio :src="getAudioUrl(topicInfo.otherRule)" controls></audio>
                </div>
                <div>
                    <div class="mt-20">请将答案按顺序依次填写在下方输入框中</div>
                    <div class="answer_one mt-15" v-for="(item, index) in topicInfo.questionContext?.options"
                        :key="index">
                        <el-input v-model="item.doAnswer" style="width: 240px" :placeholder="'答案' + (index + 1)" :disabled="topicInfo.showAnalysis" />
                    </div>
                </div>
            </div>
        </div>
        <div class="bottom_box flex flexcolumn Flexalign mt-20" v-if="!topicInfo.showAnalysis">
            <div class="btn_view cursor_pointer" @click.stop="submit">提交</div>
            <div class="view_analysis cursor_pointer" @click.stop="viewAnalysis">查看解析</div>
        </div>
        <div class="topic_answer mt-20" v-if="topicInfo.showAnalysis">
            <div class="answer_top flex FlexBetween">
                <div class="flex">
                    <div>
                        <div>参考答案：</div>
                        <div v-for="(item,index) in topicInfo.questionContext?.options" :key="index">
                            <div>填空{{ index+1 }}：{{ item.content }}</div>
                        </div>
                    </div>
                    <div class="mar_left_20">
                        <div>你的答案为：</div>
                        <div v-for="(item,index) in topicInfo.questionContext?.options" :key="index">
                            <!-- <div>填空{{ index+1 }}：{{ item.doAnswer }}</div> -->
                            <div>
            填空{{ index+1 }}：<span :class="{'wrong-answer': item.doAnswer && item.doAnswer != item.content}">{{ item.doAnswer }}</span>
        </div>
                        </div>
                    </div>
                    <div class="mar_left_20 flex">
                        <div class="full_score">总分：{{ topicInfo.questionContext?.score }}</div>
                        <div class="get_score ml-10">得分：{{ getScore() }}</div>
                    </div>
                </div>
                <!-- <div class="btn_ask">提问</div> -->
            </div>
            <div class="question_analyze mar_top_10">【试题分析】</div>
            <div class="mar_top_10" v-html="$Tools.handlerImg(topicInfo.questionAnalyze)" v-mathml></div>
            <div class="question_analyze mar_top_10">【解析】</div>
            <div class="mar_top_10" v-html="$Tools.handlerImg(topicInfo.questionExplanation)" v-mathml></div>
        </div>
    </div>
</template>

<script>
export default {
    name: "GjkcH5Fillin",
    props: {
        questionInfo: {},
        videoQuestionInfo: {}
    },

    data() {
        return {
            topicInfo: {},
        };
    },
    watch: {
        questionInfo: {
            handler(val) {
                if (val) {
                    console.log(val)
                    this.topicInfo = this.questionInfo;
                }
            },
            deep: true,
            immediate: true
        }
    },

    mounted() { },

    methods: {
        getAudioUrl(info){
            let ruleInfo = this.$Tools.jsonDecode(info);
            if(!this.$Tools.empty(ruleInfo)){
                return ruleInfo.listeningRule?.audioUrl
            }
        },
        viewAnalysis() {
            this.topicInfo.showAnalysis = true;
        },
        // 提交
        submit() {
            this.topicInfo.answerTimeSection = this.$Tools.jsonEncode(this.topicInfo.answerTimeSection);
            let params = {
                paperId: this.videoQuestionInfo.paperId,
                examId: this.videoQuestionInfo.examId,
                examScene: 5,
                isSubmit: 1,
                questions: [this.topicInfo]
            }
            this.$Api.exam.submitVideoQuestion(params).then(res => {
                console.log(res);
                this.$Dialog.toast("提交成功");
                this.viewAnalysis();
            }).catch(() => { })
        },
        getScore() {
            let questionScore = 0;
            this.topicInfo.questionContext?.options.forEach(item => {
                if (item.doAnswer == item.content) {
                    questionScore += Number(item.singleScore); // 得分
                }
            });
            return questionScore
        },
    },
};
</script>

<style lang="scss" scoped>
.topic_select {
    min-height: 360px;

    .topic_type {
        // margin-top: 1rem;
        min-width: 45px;
        padding: 0 8px;
        height: 21px;
        background: rgba(0, 199, 88, 0.2);
        border-radius: 4px;
        border: 1px solid #00c758;
        line-height: 21px;
        text-align: center;
        font-size: 12px;
        color: #00c758;
    }

    .topic_content {

        // overflow-x: auto;
        // overflow-y: clip;
        .topic_title {
            font-size: 16px;
            color: #242324;
            font-weight: 600;
        }
    }
}

.topic_select_none {
    min-height: auto;
}

.bottom_box {
    // position: absolute;
    // left: calc(50% - 60px);
    // bottom: 40px;
    text-align: center;

    .btn_view {
        width: 120px;
        height: 42px;
        background: linear-gradient(90deg, #00D5C2, #00D498);
        border-radius: 21px;
        text-align: center;
        line-height: 42px;
        color: #fff;
        font-size: 18px;
        margin: 0 auto;
    }

    .view_analysis {
        color: #13D6AA;
    }
}

.topic_answer {
    width: 100%;
    // height: 222px;
    background: rgba(19, 214, 170, 0.05);
    border-radius: 10px;
    padding: 20px;
    color: #666666;
    box-sizing: border-box;

    .answer_top {
        .error_value_answer {
            color: RGBA(255, 49, 49, 1);
        }

        .correct_value_answer {
            color: RGBA(0, 199, 88, 1);
        }

        .btn_ask {
            width: 64px;
            height: 28px;
            background: linear-gradient(90deg, #00d5c2, #00d498);
            border-radius: 14px;
            line-height: 28px;
            text-align: center;
            color: #fff;
        }
        .wrong-answer {
    color: #ff0000;
    font-weight: bold;
}
    }

    .question_analyze {
        color: #333333;
        font-weight: 600;
    }
}
</style>